import axios from 'axios';
import _ from 'lodash';
import { S3_UPLOAD_CATEGORIES } from '@/utils/Enums';

export default class ApiUtil {
   static getUserInfo = async () => {
     const response = await axios.post(
       'https://7wpccem3w8.execute-api.us-east-1.amazonaws.com/dev/auth',
       {},
     );
     const { dateOfBirth } = response.data;
     // TO-DO: Make tool to specify in a collection paths to things that can be empty arrays
     // TO-DO: Make tool to specify in a collection paths to things that can be dates
     // TO-DO: Make tool to specify in a collection paths to things that can be empty objects
     if (dateOfBirth) { // map String to Date
       response.data.dateOfBirth = new Date(dateOfBirth);
     }
     // if (!degrees) response.data.degrees = [];
     return response.data;
   };

   static getUsers = async () => {
     const response = await axios.get(
       'https://p2p3e209fb.execute-api.us-east-1.amazonaws.com/dev/users',
       {},
     );
     return response.data;
   };

  static getMissions = async () => {
    const response = await axios.get('https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions');
    return response.data;
  };

  static getMission = async (missionId) => {
    const response = await axios.get(`https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions/${missionId}`);
    return response.data;
  };

  static getAvailableMissions = async () => {
    const response = await axios.get('https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions');
    return response.data;
  };

  static userSignUpForMission = async (missionGoer, missionId) => {
    await axios.post(`https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions/${missionId}/mission-goer`,
      JSON.stringify(missionGoer));
  };

  static getPresignedUrl = async (config) => {
    const {
      s3UploadKey, method, userId,
    } = config;
    const validMethods = ['get', 'put', 'delete'];

    if (!s3UploadKey) throw new Error('No s3 upload key specified');
    if (!method) throw new Error('No presigned method specified');
    if (_.indexOf(validMethods, method) === -1) throw new Error('Invalid method: ', method);

    let endpoint = 'https://5hw8q0y12m.execute-api.us-east-1.amazonaws.com/dev/files';

    endpoint += `?key=${s3UploadKey}`;
    endpoint += `&method=${method}`;
    if (userId) endpoint += `&userId=${userId}`;

    const res = await axios.get(endpoint);
    return res.data;
  };

  static createMission = async (missionInfo) => {
    const response = await axios.post(
      'https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions',
      JSON.stringify(missionInfo),
    );
    return response;
  };

  static editMission = async (missionId, missionInfo) => {
    const response = await axios.post(
      `https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions/${missionId}`,
      JSON.stringify(missionInfo),
    );
    return response;
  };

  static putS3 = async (presignedUrl, file, options) => {
    const instance = axios.create();
    const res = await instance.put(presignedUrl, file, options);
    console.log('S3 put response', res);
    return res;
  };

  static getLocalContacts = async () => {
    const response = await axios.get('https://sio2ly5nnb.execute-api.us-east-1.amazonaws.com/dev/localContacts');
    return response.data;
  };

  static createLocalContact = async (localContactInfo) => {
    const response = await axios.post('https://sio2ly5nnb.execute-api.us-east-1.amazonaws.com/dev/localContacts',
      JSON.stringify(localContactInfo));
    return response;
  };

  static editLocalContact = async (localContactId, localContactInfo) => {
    const response = await axios.post(`https://sio2ly5nnb.execute-api.us-east-1.amazonaws.com/dev/localContacts/${localContactId}`,
      JSON.stringify(localContactInfo));
    return response;
  };
}
